module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listItem",
    class: {
      'active': _vm.active
    }
  }, [_c('div', {
    staticClass: "listItem-title"
  }, [_vm._v("\r\n    " + _vm._s(_vm.title) + "\r\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "listItem-subtitle"
  }, [_vm._v("\r\n    " + _vm._s(_vm.subtitle) + "\r\n  ")]), _vm._v(" "), (_vm.starred) ? _c('i', {
    staticClass: "i listItem-star"
  }, [_vm._v("star")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-45c78c75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitem.vue
// module id = 67
// module chunks = 0